// src/constants/legal.js
//
// Canonical URLs for Scrimly legal pages. ALL legal docs live on the
// marketing domain (getscrimly.com), not the app subdomain — this is what
// carriers (10DLC TCR), app stores, and lawyers expect, and it consolidates
// with the existing /privacy and /terms.
//
// If you add a new legal page, add it here and update every footer that
// imports LEGAL_LINKS.

export const LEGAL_URLS = Object.freeze({
  PRIVACY: 'https://getscrimly.com/privacy',
  TERMS:   'https://getscrimly.com/terms',
  SMS:     'https://getscrimly.com/sms-policy',
});

// Convenience array for rendering footers — order matters for consistency.
// labelEs: display-only Spanish labels (the documents themselves are
// English for now — Spanish legal pages are an attorney-pile item).
export const LEGAL_LINKS = Object.freeze([
  { label: 'Privacy',    labelEs: 'Privacidad',       href: LEGAL_URLS.PRIVACY },
  { label: 'Terms',      labelEs: 'Términos',         href: LEGAL_URLS.TERMS },
  { label: 'SMS Policy', labelEs: 'Política de SMS',  href: LEGAL_URLS.SMS },
]);
